import React, { useEffect } from 'react';

import Dashboard from 'components/Meteorology/Agro/Overview/Dashboard';
import DashboardMobile from 'components/Meteorology/Agro/Overview/Dashboard/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/weatherLayoutReducer';

export default function Overview() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('overview'));
  }, []);

  return isMobile ? <DashboardMobile /> : <Dashboard />;
}
